module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921121151_T.ff0fcf7e.jpg";